import { trigger } from "redial";
import { matchPath } from "react-router-dom";
import { history } from "./history";
import routes from "../routes";
import { setPageName, setPageLoading } from "../state/modules/page/actions";
import { parse } from "query-string";
import clientSideRedirect from "../state/modules/search/clientSideRedirect";
import { PAGE_NOT_FOUND } from "../state/modules/page/constants";

let shortcircuit = false;
let lastKnownGoodLocation;

const setupRouteChangeListener = store => {
  lastKnownGoodLocation = history.location;
  history.listen(location => {
    if (shortcircuit) {
      return;
    }
    const { pathname: path, search } = location;
    const activeRoute = routes.find(route => matchPath(path, route.props.path));

    if (activeRoute.key === PAGE_NOT_FOUND) {
      clientSideRedirect({ redirectUrl: `${path}${search}` });
    } else if (activeRoute.key) {
      const { dispatch, getState } = store;
      const { category } = getState();
      const catId = category.details?.id;
      const cid = parse(location.search).cid;
      const isNewPage = cid != catId;

      const locals = {
        store,
        path,
        location,
        dispatch,
        isNewPage
      };

      activeRoute.props.component.load().then(loadedComponent => {
        if (isNewPage) {
          dispatch(setPageName(activeRoute.key));
          dispatch(setPageLoading(true));
        }

        trigger("fetch", loadedComponent.default, locals).then(() => {
          const { error } = getState();

          if (error) {
            shortcircuit = true;
            history.replace(lastKnownGoodLocation);
          }
          shortcircuit = false;
          lastKnownGoodLocation = history.location;
        });
      });
    }
  });
};

export default setupRouteChangeListener;
